<p>
  {{ 'STEP2.INTRODUCTIONTEXT' | translate }}
</p>
<div *ngFor="let thickness of allowedWallThicknesses">
  <app-isomasters-button (modularClick)="updateThickness(thickness)" [selected]="thickness === selectedThickness">
    <div description>
      <span>{{ thickness }}</span>
      <span class="light-text">mm</span>
    </div>
  </app-isomasters-button>
</div>
